import React, { ReactElement, memo } from "react";
import { TEXTS } from "@payment-ui/constants/index";
import { Checkbox, CHECKBOX_ACCENT } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// test id
import { CARD_PAYMENT_METHODE_CHECKBOX_WRAPPER } from "@swiggy-private/payment-test-ids";

import styles from "../Card.v4.scss";

interface SaveCardProps {
    onCheckboxClick: (e: React.MouseEvent) => void;
    pretick: boolean;
    onCheckboxCardInfoClick: (e: React.MouseEvent) => void;
    infoCtaText: string;
}

export const CheckboxCard = memo(function SaveCard(props: SaveCardProps): ReactElement {
    return (
        <div className={styles.paymentMethodSaveDetails} data-testid={CARD_PAYMENT_METHODE_CHECKBOX_WRAPPER.CONTAINER}>
            <div onClick={props.onCheckboxClick} data-testid={CARD_PAYMENT_METHODE_CHECKBOX_WRAPPER.CHECKBOX}>
                <div className={styles.paymentMethodCheckboxWrapper}>
                    <Checkbox name={""} accent={CHECKBOX_ACCENT.SWIGGY_ORANGE} checked={props.pretick} />
                </div>
            </div>
            <div className={styles.paymentMethodSaveDetailsText}>
                <Text
                    variant="V2.body2.neutral.medium"
                    color="text_Med_Emphasis"
                    onClick={props.onCheckboxCardInfoClick}
                    data-testid={CARD_PAYMENT_METHODE_CHECKBOX_WRAPPER.LINK}
                    className={styles.paymentMethodSaveDetailsInfo}
                >
                    {props.infoCtaText}
                </Text>
                <Text
                    as="span"
                    variant="V2.body2.neutral.bold"
                    color="primary"
                    onClick={props.onCheckboxCardInfoClick}
                    data-testid={CARD_PAYMENT_METHODE_CHECKBOX_WRAPPER.LINK}
                    className={styles.paymentMethodSaveDetailsInfo}
                >
                    {TEXTS.KNOW_MORE}
                </Text>
            </div>
        </div>
    );
});
